import { ToastProps, ToastStatus } from "../components/Toast/ToastProvider.d";

let showToastFn: ((props: ToastProps) => void) | null = null;

export const initializeToast = (showToast: (props: ToastProps) => void) => {
  showToastFn = showToast;
};

export const showGlobalToast = (props: ToastProps) => {
  if (!showToastFn) {
    console.warn("Toast not initialized. Call initializeToast first.");
    return;
  }
  showToastFn(props);
};

export const errorToast = (message: string) => {
  showGlobalToast({
    status: "canceled",
    title: "Error",
    message,
    duration: 5000,
  });
};

export const successToast = (message: string) => {
  showGlobalToast({
    status: "completed",
    title: "Success!",
    message,
    duration: 3000,
  });
};

export const undoToast = (
  message: string,
  title: string,
  onUndo?: () => void
) => {
  showGlobalToast({
    status: "completed",
    title,
    message,
    duration: 3000,
    onUndo: onUndo || undefined,
  });
};

export const closeableToast = (
  message: string,
  title: string,
  status?: ToastStatus,
  onView?: () => void
) => {
  showGlobalToast({
    status: status || "completed",
    title,
    message,
    isCloseable: true,
    onView: onView || undefined,
  });
};
